export default "__VITE_ASSET__BOQ3EfJH__"